import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/sections/PageHero";
import { TexasMap } from "@/components/sections/TexasMap";
import { Services } from "@/components/sections/Services";
import { FinalCta } from "@/components/sections/FinalCta";
import { LeadForm } from "@/components/sections/LeadForm";

export default function AreasPage() {
  return (
    <main data-testid="areas-page">
      <Seo path="/service-areas" title="Solar Service Areas in Texas | Solar Energy Doc"
        description="Solar Energy Doc serves homeowners and businesses throughout Texas, including example areas like Austin, Dallas, Fort Worth, Houston and San Antonio. Contact us to confirm availability." />
      <PageHero eyebrow="Service Areas · Texas" testId="areas-page-hero" lines={["Serving Texas", "from top to bottom."]}
        sub="Solar Energy Doc proudly serves homeowners and businesses throughout Texas. Tell us where your property is located and we'll confirm availability." />
      <TexasMap />
      <Services />
      <FinalCta />
      <LeadForm />
    </main>
  );
}
